import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { useAuthToken } from "../../hooks/useAuthToken";
import { Tooltip } from "../Tooltip";
import { useTranslation } from "react-i18next";
import { useGuestId } from "../../hooks/useGuestId";
import logOut from "../Header/assets/logOut.svg";
import { Link } from "react-router-dom";

export const LogoutButton = React.memo(
  ({ isMainScreen }: { isMainScreen?: boolean }) => {
    const [, , reset] = useAuthToken();
    const [, , , , , clearIsLoggedAsGuest] = useGuestId();

    const { t } = useTranslation();
    return (
      <Tooltip label={t(isMainScreen ? "logout" : "back")}>
        {!isMainScreen ? (
          <Link to="/" className="w-6 h-6">
            <FontAwesomeIcon
              icon={faTimes}
              className="text-white"
              size="sm"
              style={{ width: "20px", height: "20px" }}
            />
          </Link>
        ) : (
          <button
            onClick={() => {
              reset();
              clearIsLoggedAsGuest();
            }}
            className="text-white"
            style={{ minWidth: "14px", minHeight: "14px" }}
          >
            <img
              style={{ minWidth: "14px", minHeight: "14px" }}
              src={logOut}
              alt=""
              className="w-4 h-4"
            />
          </button>
        )}
      </Tooltip>
    );
  }
);
